export default import.meta.ROLLUP_FILE_URL_w72avRTc5Y9iZH$EfjL0kA